export const ExpenseType = {
    LODGING: 1,
    FLIGHT: 2,
    TRANSPORTATION: 3,
    DEPENDENT_CARE: 4,
    MEALS: 5,
    CAR_SERVICE: 6,
    MILEAGE: 7
} as const;

export const getExpenseTypeOrder = (expenseType: number): number => {
    const orderMap: { [key: number]: number } = {
        [ExpenseType.LODGING]: 1,
        [ExpenseType.FLIGHT]: 2,
        [ExpenseType.TRANSPORTATION]: 3,
        [ExpenseType.CAR_SERVICE]: 3,
        [ExpenseType.MEALS]: 4,
        [ExpenseType.DEPENDENT_CARE]: 5,
        [ExpenseType.MILEAGE]: 100
    };
    return orderMap[expenseType] || 999;
};

/** Virtual file id for the mileage review page (no receipt document). */
export const MILEAGE_REVIEW_KEY = -1;
